// @ts-nocheck

export default {
	env: {
		name: "" || 'dev',
	},
	server: {
		authUserName: "riff" || 'riff',
		authPassword: "raff" || 'raff',
		baseUrl: "https://api.dev.tempstars.com/" || 'https://api.dev.tempstars.ca/',
		socketIoUrl: "https://api.dev.tempstars.com/" || 'https://api.dev.tempstars.ca/',
	},
	bucket: {
		baseUrl: "https://s3.amazonaws.com/tempstars.ca/" || 'https://s3.amazonaws.com/tempstars.ca/',
	},
	push: {
		senderID: "210360814619" || '210360814619',
	},
	stripe: {
		CA: {
			pubKey: "pk_test_yzhl7dmUrMvdEB9BaKuKhgpL" || 'pk_test_yzhl7dmUrMvdEB9BaKuKhgpL',
		},
		US: {
			pubKey: "pk_test_51MQ87TGl9ao7V0nTu1jejZxHeCDhLzjvb4Ghlqn4bXavLp6xU1yRzItnqOoYsgfyt3LpmIVnpjtB4DLvvl9Itce500F2V2yTbI" || 'pk_test_Zr5fHPeNtlFjsscMLDHTdsoA',
		},
	},
	loggly: {
		enabled: true || true,
		key: "7a96865b-dac0-4059-afcd-e08555fe10b3" || '7a96865b-dac0-4059-afcd-e08555fe10b3',
	},
	mixpanel: {
		enabled: true || false,
		token: "cabf4e03f12250df61e49f7c21e8e844" || '3e35ce85f7cf4ff6d2ccf868f22a8e04',
	},
	sendbird: {
		appId: "" || 'B2D6ED35-D3EA-4768-8F27-555762CE59FC',
		botId: "" || 'bKLrhORW_t_hhri8vIiEs',
	},
	web: {
		appUrl: "https://app.tempstars.net" || 'https://app.tempstars.net',
		CA: {
			siteUrl: "www.tempstars.ca" || 'www.tempstars.ca',
		},
		US: {
			siteUrl: "www.tempstars.com" || 'www.tempstarsapp.com',
		},
	},
	CA: {
		helpEmail: "help@tempstars.ca" || 'help@tempstars.com',
		tempAmount: "$47+hst" || '$73+hst',
		tokensLink: "" || 'http://www.tempstars.ca/tokens',
	},
	US: {
		helpEmail: "help@tempstarsapp.com" || 'help@tempstarsapp.com',
		tempAmount: "$25" || '$38',
		tokensLink: "" || 'http://www.tempstarsapp.com/tokens',
	},
	debug: false || true,
	testMode: false || true,
}
